import { render, staticRenderFns } from "./AllDays.vue?vue&type=template&id=23be5ddb"
import script from "./AllDays.vue?vue&type=script&lang=js"
export * from "./AllDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports